import { render } from "./ProductTypeList.vue?vue&type=template&id=59d6a986&scoped=true&ts=true"
import script from "./ProductTypeList.vue?vue&type=script&lang=ts"
export * from "./ProductTypeList.vue?vue&type=script&lang=ts"

import "./ProductTypeList.vue?vue&type=style&index=0&id=59d6a986&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d6a986"]])

export default __exports__